import { Outlet } from "@tanstack/react-router";
import { useState } from "react";

import { Rail } from "./Rail";
import { TopBar } from "./TopBar";

export function RootLayout() {
  const [railOpen, setRailOpen] = useState(false);

  return (
    <div style={frameStyle} className="sk-frame">
      <Rail open={railOpen} onNavigate={() => setRailOpen(false)} />
      <div style={rightStyle}>
        <TopBar onMenuClick={() => setRailOpen((v) => !v)} />
        {railOpen ? (
          <button
            type="button"
            aria-label="Close menu"
            className="sk-rail-backdrop"
            onClick={() => setRailOpen(false)}
          />
        ) : null}
        <main style={mainStyle}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}

const frameStyle: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "64px 1fr",
  // Explicit single row of exactly one viewport, shrinkable to 0, so the
  // scrollable <main> is contained instead of growing the page past 100vh.
  gridTemplateRows: "minmax(0, 1fr)",
  height: "100%",
  minHeight: 0,
  background: "var(--sk-bg, var(--sk-color-surface-1))",
  color: "var(--sk-text, var(--sk-color-ink-1))",
};

const rightStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  minWidth: 0,
  minHeight: 0,
};

const mainStyle: React.CSSProperties = {
  flex: 1,
  overflow: "auto",
  minHeight: 0,
  padding: "0 20px 20px",
};
